import React, { Component } from "react";
import { Input, TreeSelect, Modal } from "antd";

const { TextArea } = Input;

class AddMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      value: "",
      typeKey1: null,
      typeKey2: null,
    };
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    let save = {
      content: this.state.value,
      typeKey1: this.state.typeKey1,
      typeKey2: this.state.typeKey2,
    };
    this.props.getAddGroupLists(save);
    this.setState({
      visible: false,

      typeKey1: null,
      typeKey2: null,
      value: "",
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  onChange(e) {
    this.setState({
      value: e.target.value,
    });
  }
  render() {
    const treeData = JSON.parse(
      JSON.stringify(this.props.currentMenuList)
        .replace(/name/g, "title")
        // .replace(/sons/g, "children")
        .replace(/id/g, "value")
    );
    const treeData2 = JSON.parse(
      JSON.stringify(this.props.selectMenuList)
        .replace(/name/g, "title")
        // .replace(/sons/g, "children")
        .replace(/id/g, "value")
    );
    return (
      <div>
        <Modal
          title="新增消息"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          bodyStyle={{ height: "400px" }}
          width="700px"
        >
          <div>
            <TextArea
              rows={4}
              value={this.state.value}
              onChange={(e) => this.onChange(e)}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <div>发布对象</div>
            <div>
              <TreeSelect
                placeholder="请选择"
                style={{ width: "200px" }}
                value={this.state.typeKey1}
                treeData={treeData}
                onChange={(value) => {
                  console.log(value);
                  this.state.typeKey1 = value;
                  this.setState({});
                  this.props.getItemGroupLists(this.state.typeKey1);
                }}
              />
            </div>
            <div>
              <TreeSelect
                placeholder="请选择"
                style={{ width: "200px" }}
                value={this.state.typeKey2}
                treeData={treeData2}
                onChange={(value) => {
                  // console.log(value);
                  this.state.typeKey2 = value;
                  this.setState({});
                }}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default AddMessage;
